import { render, staticRenderFns } from "./form4.vue?vue&type=template&id=e28831d6&scoped=true"
import script from "./form4.vue?vue&type=script&lang=js"
export * from "./form4.vue?vue&type=script&lang=js"
import style0 from "./form4.vue?vue&type=style&index=0&id=e28831d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e28831d6",
  null
  
)

export default component.exports